module.exports = __webpack_public_path__ + "images/last_point_unArrived.4203e578ac97920de834262b41d10c30.png";